import {MuNamedWidgets, MuWidget} from "mu-widget/lib/MuWidget";
import {TodoCL} from "../generated/TodoCL";
import {UiTomSelect} from "../components/UiTomSelect";
import {TomOption} from "tom-select/dist/types/types";
import {UiDms} from "../dms/UiDms";
import {data} from "browserslist";
import {UiFlashMessage} from "../UiFlashMessage";
import {MuBinder} from "mu-widget/lib/MuBinder";

export class UiTodoButton extends MuWidget {
	public oid: string;

	public cl: TodoCL;

	afterIndex() {
		this.cl = new TodoCL();

	}

	beforeIndex() {
		this.muAppendContent(`
			<span class="icon-todo cursor-pointer" mu-id="bOpenTodoFor"></span>
			<div mu-widget="UiTodoDialog" mu-template="todoDialog"></div>
		`);
	}

	bOpenTodoFor_click() {
		this.muWidgetFromTemplate(
			'todoDialog',
			MuWidget.root.ui.modals,
			{
				oid: this.oid,
				cl: this.cl
			}
		);
	}
}

export class UiTodoDialog extends MuWidget {
	// @ts-ignore
	public oid: string;

	// @ts-ignore
	public cl: TodoCL;

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		editor: UiTodoEditor,
		list: UiTodoList,
	}>;

	beforeIndex() {
		this.muAppendContent(`<div class="modal-i">
			<div class="modal-title">
				<h2>Seznam poznámek</h2>
				<span class="close" mu-id="btCloseModal" mu-click="muRemoveSelf">×</span>
			</div>
			<div mu-id="editor" mu-widget="UiTodoEditor"></div>
			<h3>Existující poznámky</h3>
			<div mu-id="list" mu-widget="UiTodoList"></div>
		</div>`);
	}

	afterIndex() {
		this.muNamedWidget.editor.oid = this.oid;
		this.muNamedWidget.editor.cl = this.cl;
		this.muNamedWidget.list.oid = this.oid;
		this.muNamedWidget.list.cl = this.cl;
	}

	async list_archive(ev, id: number) {
		await this.cl.archiveTodoItem(id);
		this.muNamedWidget.list.reload();
	}

	async list_edit(ev, id: number) {
		this.muNamedWidget.editor.bindItem((await this.cl.getTodoItemById(id)).entity);
	}

	async editor_saved() {
		this.muNamedWidget.list.reload();
		this.muNamedWidget.editor.bindItem(null);
	}
}

export class UiTodoEditor extends MuWidget {
	// @ts-ignore
	public oid: string;

	// @ts-ignore
	public cl: TodoCL;

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		tags: UiTomSelect
	}>;

	public presetDtAdd: { label: string, duration: number|null }[] = [
		{ duration: 24, label: '+1 den' },
		{ duration: 48, label: '+2 dny' },
		{ duration: 7 * 24, label: '+ týden' },
		{ duration: 30 * 24, label: '+ měsíc' },
		{ duration: null, label: 'Bez termínu' },
	];
	private id: null | number;

	beforeIndex() {
		this.muAppendContent(`
			<h3 mu-id="title"></h3>
			<div class="form-group row">
				<label class="col-md-3" mu-for="summary">Souhrn</label>
				<div class="col-md-9">
					<input type="text" class="form-control" mu-bind="summary" />
				</div>
			</div>
			<div class="form-group row">
				<label class="col-md-3" mu-for="note">Poznámka</label>
				<div class="col-md-9">
					<textarea class="form-control" mu-bind="note"></textarea>
				</div>
			</div>
			<div class="form-group row">
				<label class="col-md-3" mu-for="calItemDt">Datum a čas</label>
				<div class="col-md-4">
					<input class="form-control" mu-bind="calItemDt|dateToInput::value" mu-id="calItemDt" type="datetime-local" />
				</div>
				<div class="col-md-5 text-center">`
			+ this.presetDtAdd.map(pr => '<span class="a" mu-click="addDtDuration: ' + pr.duration + '">' + pr.label + '</span>').join(' ')
			+ `</div>
			</div>
			<div class="form-group row">
				<label class="col-md-3" mu-for="calItemDt">Štítky</label>
				<div class="col-md-9">
					<div mu-widget="UiTomSelect" mu-bind="tags" mu-id="tags"></div>
				</div>
			</div>
			<div>
				<span class="btn btn-primary" mu-id="bSave">Uložit</span>
				<span class="btn btn-primary" mu-id="bCancel">Zavřít bez uložení</span>
				<span class="btn btn-primary" mu-id="bArchive">Archivovat</span>
			</div>
		`);
		this.muRegisterEvent('saved');
	}

	afterIndex() {
		this.muParent.muOnAfterIndex.push(async () => {
			const tagsClt = this.muNamedWidget.tags;
			tagsClt.labelField = "name";
			tagsClt.valueField = "id";
			tagsClt.canCreate = true;
			tagsClt.multiple = true;
			tagsClt.init();
			tagsClt.bindItems((await this.cl.getMyTags()).entityList);
			this.bindItem(null);
		});
	}

	addDtDuration(ev: any, duration: number|null) {
		let dt : Date|null = this.ui.calItemDt.value
			? new Date(this.ui.calItemDt.value)
			: new Date();
		if (duration) {
			dt.setHours(dt.getHours() + duration);
		} else dt = null;

		this.ui.calItemDt.value = dt
			? MuBinder.filters.dateToInput(dt)
			: "";
	}

	bindItem(data: any|null) {
		this.ui.title.innerText = data ? "Upravit poznámku" : "Přidat poznámku";
		this.muVisible(!!data || !!this.oid, this.container);
		data = data || {
			note: '',
			calItemDt: '',
			tags: [],
			id: null,
			summary: '',
		};
		this.id = data.id;
		this.muBindData(data);
		this.muVisible(!!data.id, ["bCancel", "bArchive"]);
	}

	async bSave_click() {
		const data = this.muFetchData();
		const res = this.id
			? await this.cl.updateTodoItem(data, this.id)
			: await this.cl.createTodoItem(data, this.oid);

		this.muDispatchEvent('saved', res);
	}

	bCancel_click() {
		this.bindItem(null);
	}

	async bArchive_click() {
		if (this.id) await await this.cl.archiveTodoItem(this.id);
		this.muDispatchEvent('saved', null);
	}
}

export class UiTodoList extends MuWidget {
	// @ts-ignore
	public oid: string;

	// @ts-ignore
	public cl: TodoCL;

	beforeIndex() {
		this.muAppendContent(`
		<div class="todo-list" mu-id="list" mu-bind="list:@foreach">
			<div class="todo-list__item" mu-widget="UiTodoListItem" mu-template="item"></div>
		</div>
		`);
		this.muRegisterEvent('edit', 'archive');
	}

	afterIndex() {
		this.muParent.muOnAfterIndex.push(async () => this.reload());
	}

	async reload(filter: any) {
		const data = await this.cl.findTodoItemsBy(
			filter || {
				oid: this.oid
			},
			false
		);
		this.muBindData({ list: data.entityList } );
	}

	archiveItem(id: number) {
		this.muDispatchEvent('archive', id);
	}

	editItem(id: number) {
		this.muDispatchEvent('edit', id);
	}
}

export class UiTodoListItem extends MuWidget {
	// @ts-ignore
	private id: number;

	// @ts-ignore
	muParent: UiTodoList;

	beforeIndex() {
		this.muAppendContent(`
			<div class="display-flex">
				<h4 mu-bind="summary" class="flex-grow-1"></h4>
				<a mu-bind="targetLink:href;targetName" class="flex-grow-1"></a>
				<div mu-bind='dtCreated|dateTime("d.m.Y H:i")'></div>
			</div>
			<div mu-bind="note"></div>
			<div mu-bind="dt"></div>
			<div class="display-flex">
				<div mu-bind="tagNames:@foreach" class="flex-grow-1">
					<span class="label label-default" mu-template="item" mu-widget="."><span mu-bind="name"></span></span>
				</div>
				<span mu-bind="calItemDt|dateTime;calItemDt:@visible" class="icon-before-calendar"></span>
				<div>
					<span class="btn btn-primary"><span mu-id="bEdit" class="icon-before-edit">Upravit</span></span>
					<span class="btn btn-warning"><span mu-id="bArchive" class="icon-before-archive">Archivovat</span></span>
				</div>
			</div>
		`);
	}

	muBindData(srcData: any) {
		super.muBindData(srcData);
		this.id = srcData.id;
	}

	bEdit_click() {
		this.muParent.editItem(this.id);
	}

	bArchive_click() {
		this.muParent.archiveItem(this.id);
	}
}

export class UiTodoPage extends MuWidget {

	// @ts-ignore
	public cl: TodoCL;

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		filter: UiTodoFilter,
		list: UiTodoList,
		editor: UiTodoEditor,
	}>;

	beforeIndex() {
		this.muAppendContent(`<h3>Poznámky</h3>
			<div mu-id="editor" mu-widget="UiTodoEditor"></div>
			<div mu-id="filter" mu-widget="UiTodoFilter"></div>
			<div class="row">
				<div class="col-md-3" >
					<div mu-id="filterPresets" mu-bind="filterPresets:@foreach" class="list-group">
						<span mu-template="item" mu-widget="UiTodoFilterPreset" class="list-group-item a "></span>
					</div>
				</div>
				<div mu-id="list" mu-widget="UiTodoList" class="col-md-9"></div>
			</div>
		`);
	}

	afterIndex() {
		this.cl = new TodoCL();
		this.muNamedWidget.editor.cl = this.cl;
		this.muNamedWidget.list.cl = this.cl;
		this.bindFilterPresets();
	}

	async list_archive(ev, id: number) {
		await this.cl.archiveTodoItem(id);
		this.muNamedWidget.list.reload();
	}

	async list_edit(ev, id: number) {
		this.muNamedWidget.editor.bindItem((await this.cl.getTodoItemById(id)).entity);
	}

	async editor_saved() {
		this.muNamedWidget.list.reload();
		this.muNamedWidget.editor.bindItem(null);
	}

	private async bindFilterPresets(): Promise<void> {
		const nowTime = (h:number, m:number, s:number) => {
			const dt = new Date();
			dt.setHours(h, m, s);
			return dt;
		};
		const presets: { name: string, filter: { tags?: string[], calItemDtFrom?: Date | null, calItemDtTo?: Date | null } }[] = [];
		for (const _i of [
			["Dnes", nowTime(0, 0, 0), nowTime(23, 59, 59)],
			["Zitra", nowTime(24, 0, 0), nowTime(47, 59, 59)],
			["Dalších 7 dnů", nowTime(0, 0, 0), nowTime(6 * 24, 59, 59)],
		]) {
			let name: string, calItemDtFrom: null | Date, calItemDtTo: null | Date;
			[name, calItemDtFrom, calItemDtTo] = _i;
			presets.push({
				name: name,
				filter: {calItemDtFrom, calItemDtTo, tags: []}
			});
		}
		for (const tag of (await this.cl.getMyTags()).entityList) {
			presets.push({
				name: tag.name,
				filter: {tags: [tag.id], calItemDtFrom: null, calItemDtTo: null}
			});
		}

		this.muBindData({filterPresets : presets});
	}

	async setFilter(filter) {
		this.muNamedWidget.filter.muBindData(filter);
		this.muNamedWidget.filter.bSearch_click();
	}


}

export class UiTodoFilter extends MuWidget {
	muParent: UiTodoPage;

	beforeIndex() {
		this.muAppendContent(`
			<div class="display-flex flex-items-grow-1">
				<span class="flex-grow-0">Štítek</span>
				<div mu-widget="UiTomSelect" mu-id="tags" mu-bind="tags"></div>
				<span class="flex-grow-0">Datum od</span>
				<input type="datetime-local" class="form-control flex-grow-0" mu-bind="calItemDtFrom|dateToInput" style="width: 20ex" />
				<span class="flex-grow-0">do</span>
				<input type="datetime-local" class="form-control flex-grow-0" mu-bind="calItemDtTo|dateToInput" style="width: 20ex" />
			</div>
			<div class="display-flex">
				<input type="search" class="form-control flex-grow-1" mu-bind="fulltext" />
				<span class="btn btn-link icon-before-search" mu-id="bSearch">Vyhledat</span>
			</div>
		`);
	}

	afterIndex() {
		setupTagSelector(this.muNamedWidget.tags);
	}

	bSearch_click() {
		this.muParent.muNamedWidget.list.reload(this.muFetchData());
	}
}

export class UiTodoFilterPreset extends MuWidget {

	public filterSetting: any;

	muParent: UiTodoPage;

	beforeIndex() {
		this.muAppendContent(`<span mu-bind="name"></span>`);
		// this.muRegisterEvent('selected');
	}
	container_click() {
		// this.muDispatchEvent("selected", this.filterSetting)
		this.muParent.setFilter(this.filterSetting);
	}

	muBindData(srcData: any) {
		super.muBindData(srcData);
		this.filterSetting = srcData.filter;
	}
}

async function setupTagSelector(tomSelect: UiTomSelect) {
	tomSelect.labelField = "name";
	tomSelect.valueField = "id";
	tomSelect.canCreate = true;
	tomSelect.multiple = true;
	tomSelect.init();
	tomSelect.bindItems((await (new TodoCL()).getMyTags()).entityList);
}